import { Path, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormInput } from "src/core/components/custom-ui/form-input";

export type CreateClientEIFormBase = {
  prenomEI: string;
  nomEI: string;
  dateDeNaissanceEI: string;
};

export const CreateClientEIForm = <T extends CreateClientEIFormBase>({
  form,
}: {
  form: UseFormReturn<T>;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-y-10">
      <div className="flex flex-row items-center justify-between">
        <FormInput
          control={form.control}
          name={"prenomEI" as Path<T>}
          label={t("form.createClient.prenomEI")}
          className="w-[200px]"
          required
          borderErrorClass={
            form.formState.errors.prenomEI?.type === "potentialDuplicate"
              ? "border-orange-medium"
              : "border-alert"
          }
          labelErrorClass={
            form.formState.errors.prenomEI?.type === "potentialDuplicate" ||
            form.formState.errors.prenomEI?.type === "duplicate"
              ? "text-foreground"
              : "text-alert"
          }
        />
        <FormInput
          control={form.control}
          name={"nomEI" as Path<T>}
          label={t("form.createClient.nomEI")}
          className="w-[200px]"
          required
          borderErrorClass={
            form.formState.errors.nomEI?.type === "potentialDuplicate"
              ? "border-orange-medium"
              : "border-alert"
          }
          labelErrorClass={
            form.formState.errors.nomEI?.type === "potentialDuplicate" ||
            form.formState.errors.nomEI?.type === "duplicate"
              ? "text-foreground"
              : "text-alert"
          }
        />
        <FormInput
          type="date"
          control={form.control}
          name={"dateDeNaissanceEI" as Path<T>}
          label={t("form.createClient.dateDeNaissanceEI")}
          className="w-[200px]"
          required
          borderErrorClass={
            form.formState.errors.dateDeNaissanceEI?.type === "potentialDuplicate"
              ? "border-orange-medium"
              : "border-alert"
          }
          labelErrorClass={
            form.formState.errors.dateDeNaissanceEI?.type === "potentialDuplicate" ||
            form.formState.errors.dateDeNaissanceEI?.type === "duplicate"
              ? "text-foreground"
              : "text-alert"
          }
        />
      </div>
      {form.formState.errors.prenomEI?.type === "duplicate" && (
        <p className="text-alert text-xs font-light">
          {t("form.createClient.error.raisonSocialeAlreadyExists")}
        </p>
      )}
    </div>
  );
};
